var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.826,
    height: 61.474,
    viewBox: "0 0 46.826 61.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ff6875;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M0,365.4V378.25H46.826V365.4a5.409,5.409,0,0,0-5.4-5.4H5.4A5.409,5.409,0,0,0,0,365.4Zm3.6,0a1.8,1.8,0,0,1,1.8-1.8H7.2v11.046H3.6Zm7.2-1.8h4.657l7.95,7.95,7.95-7.95H36.02v11.046H10.806Zm32.418,1.8v9.245h-3.6V363.6h1.8A1.8,1.8,0,0,1,43.224,365.4Zm-16.955-1.8-2.856,2.856L20.557,363.6Zm0,0",
    transform: "translate(0 -316.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M36.883,36.02h2.738v-3.6h1.8a5.409,5.409,0,0,0,5.4-5.4v-3.6A23.413,23.413,0,0,0,0,23.413v3.6a5.409,5.409,0,0,0,5.4,5.4H8.131a16.2,16.2,0,0,0,28.752,3.6Zm4.539-7.2h-1.9a16.2,16.2,0,0,0,.1-1.8v-3.6a16.2,16.2,0,0,0-.1-1.8h1.9a1.8,1.8,0,0,1,1.8,1.8v3.6A1.8,1.8,0,0,1,41.422,28.816ZM23.413,3.6A19.846,19.846,0,0,1,42.5,18.119a5.405,5.405,0,0,0-1.082-.109H38.694a16.209,16.209,0,0,0-30.563,0H5.4a5.405,5.405,0,0,0-1.082.109A19.846,19.846,0,0,1,23.413,3.6ZM33.755,16.213a12.658,12.658,0,0,1-10.343,5.4H10.935a12.6,12.6,0,0,1,22.821-5.4ZM5.4,28.816a1.8,1.8,0,0,1-1.8-1.8v-3.6a1.8,1.8,0,0,1,1.8-1.8H7.3a16.2,16.2,0,0,0-.1,1.8v3.6a16.2,16.2,0,0,0,.1,1.8Zm5.4-1.8v-1.8H23.413a16.27,16.27,0,0,0,12.08-5.407,12.549,12.549,0,0,1,.527,3.606v3.6a12.533,12.533,0,0,1-1.218,5.4H28.815l-1.582-1.582a5.4,5.4,0,0,1-7.641,0l-2.547,2.547a9.005,9.005,0,0,0,11.77.837v1.8h3.41a12.6,12.6,0,0,1-21.42-9Zm0,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4e40b54ebb87af71d5e3c56d422e945e.svg";
export { ForwardRef as ReactComponent };